var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "scatter-chart" },
    [
      _vm.chartOptions
        ? _c("VueApexChart", {
            ref: "chart",
            staticClass: "app-chart-scatter",
            class: { live: _vm.autoUpdate },
            attrs: {
              width: "100%",
              height: "100%",
              options: _vm.chartOptions,
              series: _vm.series
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._m(0)
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "legend-container" }, [
      _c("div", { staticClass: "item-wrapper" }, [
        _c("div", { staticClass: "circle positive" }),
        _vm._v(" "),
        _c("p", { staticClass: "label" }, [_vm._v("Positive")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item-wrapper" }, [
        _c("div", { staticClass: "circle neutral" }),
        _vm._v(" "),
        _c("p", { staticClass: "label" }, [_vm._v("Neutral")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item-wrapper" }, [
        _c("div", { staticClass: "circle negative" }),
        _vm._v(" "),
        _c("p", { staticClass: "label" }, [_vm._v("Negative")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-95957838", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95957838","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-components/AppChartScatter.vue
// module id = null
// module chunks = 